import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Consumable, ConsumableWrite } from '../models/consumable.model';

@Injectable({ providedIn: 'root' })
export class ConsumableService {
  private http = inject(HttpClient);
  private apiUrl = '/quotes-api/consumables/';

  private consumablesSubject = new BehaviorSubject<Consumable[]>([]);
  public consumables$ = this.consumablesSubject.asObservable();

  private activeConsumablesSubject = new BehaviorSubject<Consumable[]>([]);
  public activeConsumables$ = this.activeConsumablesSubject.asObservable();

  async loadConsumables(): Promise<void> {
    const rows = await firstValueFrom(this.http.get<unknown[]>(this.apiUrl));
    const parsed = rows.map((row) => Consumable.parse(row));
    this.activeConsumablesSubject.next(
      parsed.filter((row) => !row.is_archived),
    );
    this.consumablesSubject.next(parsed);
  }

  async createConsumable(data: ConsumableWrite): Promise<Consumable> {
    const created = await firstValueFrom(
      this.http.post<unknown>(this.apiUrl, data),
    );
    await this.loadConsumables();
    return Consumable.parse(created);
  }

  async updateConsumable(
    id: number,
    data: Partial<ConsumableWrite>,
  ): Promise<Consumable> {
    const updated = await firstValueFrom(
      this.http.patch<unknown>(`${this.apiUrl}${id}/`, data),
    );
    await this.loadConsumables();
    return Consumable.parse(updated);
  }
}
